import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { imgUrl } from "@/context/SiteContext";

export default function ImageUpload({ value, onChange, testid, label = "Unggah Gambar" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 8 * 1024 * 1024) return toast.error("Ukuran gambar maksimal 8MB");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url);
      toast.success("Gambar terunggah");
    } catch (er) {
      toast.error(errMsg(er));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mt-1 flex items-center gap-3" data-testid={testid}>
      <div className="grid h-16 w-24 shrink-0 place-items-center overflow-hidden border border-slate-300 bg-slate-50">
        {value ? <img src={imgUrl(value)} alt="" className="h-full w-full object-cover" data-testid={`${testid}-preview`} /> : <span className="text-[10px] text-slate-400">Tidak ada</span>}
      </div>
      <button type="button" disabled={busy} onClick={() => ref.current?.click()} className="inline-flex items-center gap-1.5 border border-slate-300 bg-white px-3 py-2 text-xs font-semibold hover:border-[#D97706] disabled:opacity-60" data-testid={`${testid}-button`}>
        <Upload size={12} /> {busy ? "Mengunggah..." : label}
      </button>
      {value && <button type="button" onClick={() => onChange("")} className="p-1 text-rose-600" data-testid={`${testid}-clear`}><X size={14} /></button>}
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml,image/gif" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
    </div>
  );
}
